export const normalizeWhatsappNumber = (value) => (value || "").replace(/\D/g, "");

export const normalizePhoneHref = (value) => (value || "").replace(/[^\d+]/g, "");

export const buildMailtoHref = (email, { subject = "", body = "" } = {}) => {
  if (!email) {
    return "";
  }

  const params = new URLSearchParams();

  if (subject) {
    params.set("subject", subject);
  }

  if (body) {
    params.set("body", body);
  }

  const query = params.toString();
  return `mailto:${email}${query ? `?${query}` : ""}`;
};

export const getPrimaryContactAction = (
  contact,
  {
    whatsappMessage = "",
    emailSubject = "",
    emailBody = "",
    fallbackHref = "/contacto",
  } = {},
) => {
  const whatsappNumber = normalizeWhatsappNumber(contact?.sales_whatsapp);

  if (whatsappNumber) {
    const message = whatsappMessage ? `?text=${encodeURIComponent(whatsappMessage)}` : "";

    return {
      type: "whatsapp",
      href: `https://wa.me/${whatsappNumber}${message}`,
      target: "_blank",
      rel: "noreferrer",
      value: contact?.sales_whatsapp || "",
      label: contact?.sales_label || "WhatsApp",
    };
  }

  if (contact?.main_email) {
    return {
      type: "email",
      href: buildMailtoHref(contact.main_email, { subject: emailSubject, body: emailBody }),
      value: contact.main_email,
      label: contact?.sales_label || "Email",
    };
  }

  const officePhone = normalizePhoneHref(contact?.office_phone);

  if (officePhone) {
    return {
      type: "phone",
      href: `tel:${officePhone}`,
      value: contact?.office_phone || "",
      label: contact?.sales_label || "Phone",
    };
  }

  return {
    type: "fallback",
    href: fallbackHref,
    value: fallbackHref,
    label: contact?.header_cta_label || "Contact",
  };
};